export const AWARD_ERR_CODE = {
  SUCCESS: 0,
  UNDERSTOCK: 1, // 奖品无库存
  TIMEOUT: 2 // 上游服务超时
};

// 奖励页 tab reward type
export const TAB_REWARD_TYPE = {
  AWARDS_RECORD: 10
};
